module.exports = __webpack_public_path__ + "static/img/alipay-pay-help.58272224.png";